import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// Icons
import { XCircleIcon } from '@heroicons/vue/solid';

interface Props {
  data?: {
    status: number;
    errors: Array<{
      message: string;
      field: string;
      indexes: [];
      params: [];
    }>;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'errors',
  props: {
    data: { type: Object, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  data?: {
    status: number;
    errors: Array<{
      message: string;
      field: string;
      indexes: [];
      params: [];
    }>;
  };
}



const grouped_message = computed(() => {
  if (props.data && props.data.errors && props.data.errors.length === 1) {
    return props.data.errors[0].message;
  } else {
    return 'internal_error';
  }
});

const getFields = (e: { message: string; field: string; indexes: []; params: [] }) => {
  const fields: string[] = [];

  if (e.field !== '') {
    fields.push(e.field);
  }
  if (!e.params) {
    e.params = [];
  }

  return [...fields, ...e.params];
};

const __returned__ = { props, grouped_message, getFields, XCircleIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})